import React from 'react';
import Modal from '../../../BaseComponents/Modal';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const ViewRecommendation = ({ isOpen, onClose }: Props) => {
  const { recommendationToView } = useSelector(
    (state: RootState) => state.recommendations
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose}
      title={'Recommendation'}
      width={'900px'}>

      <div className='recommendation-modal-form'>
        <div>
          <img alt={recommendationToView?.title || ''} src={recommendationToView?.image_url || ''} width={'100'} height={'100'} />
        </div>
        <h3>{recommendationToView?.title}</h3>
        <p>{recommendationToView?.description}</p>
      </div>
    </Modal>
  );
};

export default ViewRecommendation;
